import React from "react";
import { Container } from "react-bootstrap";
import * as s from "./index.module.scss";
import Link from "next/link";
import { IoArrowForward } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import useEmblaCarousel from "embla-carousel-react";

const WhatWeBuy = ({ data }) => {
  const [emblaRef] = useEmblaCarousel({ align: "start" });

  return (
    <section className={`section-center ${s.what_we_buy}`}>
      <Container className={s.container_box}>
        <h2 className="heading text-center">{data?.title}</h2>
        <div className={s.grid_view}>
          <section className="embla__what_we_buy">
            <div className="embla__viewport" ref={emblaRef}>
              <div className="embla__container">
                {data?.data.map((item, index) => (
                  <div className="embla__slide" key={index}>
                    <div className={`${s.card_view}`}>
                      <Link href={item?.view_more_link}>
                        <img
                          src={item?.image.url}
                          alt={item?.image.alt || "image"}
                          height="100%"
                          width="100%"
                          loading={"lazy"}
                        />
                        <div className={`${s.content} ${secondaryFont}`}>
                          <div>
                            <h3>{item?.label}</h3>
                            <p>{item?.description}</p>
                          </div>
                          <span className={s.view_link}>
                            View More <IoArrowForward size="18px" />
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>

        <div className={s.view_all}>
          <Link
            className={`${secondaryFont} btn btn-outline-dark ${s.view_all_link}`}
            href="/what-we-buy"
          >
            View all what we buy{" "}
            <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default WhatWeBuy;
